import TYPES from '@/modules/shared/types';

// Domain
import { AllianzOperationDatesRepository } from '../../domain/repository';
import { AllianzOperationDatesEntity } from '../../domain/entities/allianz-operation-dates-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class AllianzOperationDatesHttpRepository implements
  AllianzOperationDatesRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/transactions-operation-dates/`;

  get(transaction_type_id: string): Promise<AllianzOperationDatesEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.concat(`${transaction_type_id}/`))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
